import { render, staticRenderFns } from "./RepoAnalysisSettings.vue?vue&type=template&id=5428b200"
import script from "./RepoAnalysisSettings.vue?vue&type=script&lang=ts"
export * from "./RepoAnalysisSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZInput: require('/app/components/zeal/ZInput/ZInput.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,ZAlert: require('/app/components/zeal/ZAlert/ZAlert.vue').default,ZDivider: require('/app/components/zeal/ZDivider/ZDivider.vue').default,ToggleInputV2: require('/app/components/Form/ToggleInputV2.vue').default,ZRadio: require('/app/components/zeal/ZRadio/ZRadio.vue').default,ZRadioGroup: require('/app/components/zeal/ZRadioGroup/ZRadioGroup.vue').default})
